import { Button, Flex, Spin, Typography } from 'antd'
import { useNavigate } from 'react-router-dom'

import { SchoolService } from '@services/SchoolService'
import { useConfirmation } from '@store/confirmation'
import { useNotifications } from '@store/notifications'

import type { School } from '../../../../types'

export const DangerZoneTab = ({ school }: { fetch: () => Promise<void>; school: School }) => {
    const confirm = useConfirmation()
    const { showNotification } = useNotifications()
    const navigate = useNavigate()

    const onDeleteSchool = async () => {
        if (!school) {
            return
        }

        if (
            await confirm({
                title: 'Are you sure you want to delete this school?',
                confirmText: 'Delete'
            })
        ) {
            try {
                await SchoolService.remove(school.id!)
                navigate('/schools')
            } catch (err: any) {
                showNotification({
                    title: 'School deletion failed',
                    type: 'error',
                    description: err.response.data
                })
            }
        }
    }

    if (!school) {
        return <Spin />
    }

    return (
        <>
            <Typography.Text>Please remove all users from the school prior to deleting</Typography.Text>
            <Flex>
                <Button type="primary" danger onClick={onDeleteSchool} disabled={school.schoolUsers.length > 0}>
                    Delete School
                </Button>
            </Flex>
        </>
    )
}
